import { render, staticRenderFns } from "./Diligencia.vue?vue&type=template&id=0880dfcc&scoped=true"
import script from "./Diligencia.vue?vue&type=script&lang=js"
export * from "./Diligencia.vue?vue&type=script&lang=js"
import style0 from "./Diligencia.vue?vue&type=style&index=0&id=0880dfcc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0880dfcc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0880dfcc')) {
      api.createRecord('0880dfcc', component.options)
    } else {
      api.reload('0880dfcc', component.options)
    }
    module.hot.accept("./Diligencia.vue?vue&type=template&id=0880dfcc&scoped=true", function () {
      api.rerender('0880dfcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/notificaciones/Diligencia.vue"
export default component.exports